import { css } from '@/styled-system/css';

export const stackedViewActionStyles = css.raw({
  display: { base: 'flex', md: 'grid' },
  gridTemplateRows: 'auto auto',
  gridTemplateColumns: '1fr 1fr',
  gap: 'tight',
  marginTop: 'default',
});

export const defaultViewActionStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 'tight',
  marginLeft: { base: 'none', md: 'auto' },
  marginTop: { base: 'default', md: 'none' },
});

export const cardStyles = css.raw({
  borderLeftWidth: '3px',
  display: 'flex',
  flexDirection: 'column',
  flexFlow: 'column wrap',
  paddingInline: 'loose',
});
